import {
  highwayColour,
  otherColour,
  parkColour,
  // riverColour,
  schoolColour,
  socialHousingColour,
  // welandColour,
} from "./colours";

export const initialSitesProprties = {
  Highway: { color: highwayColour, visible: true, pathOfName: "context" },
  Park: { color: parkColour, visible: true, pathOfName: "context" },
  School: { color: schoolColour, visible: true, pathOfName: "context" },
  "Social Housing": {
    color: socialHousingColour,
    visible: true,
    pathOfName: "context",
  },
  // Wetland: { color: welandColour, visible: true, pathOfName: "context" },
  // "River restoration / flood storage / defence": {
  //   color: riverColour,
  //   visible: true,
  //   pathOfName: "context",
  // },
  Other: { color: otherColour, visible: true, pathOfName: "context" },
};
